import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { AuthContextState } from '@xometry/auth-context/dist/types';
import Logger from '../Logger';

interface CoralogixContextType {
  isInitialized: boolean;
}

const CoralogixContext = createContext<CoralogixContextType>({
  isInitialized: false,
});

interface CoralogixProviderProps {
  children: ReactNode;
  user?: AuthContextState['user'];
}

export const CoralogixProvider: React.FC<CoralogixProviderProps> = ({
  children,
  user,
}) => {
  const [isInitialized, setIsInitialized] = React.useState(false);

  useEffect(() => {
    // Set initialization status based on coralogix logger state
    setIsInitialized(true);

    // Set user context when user changes
    if (user) {
      Logger.setUserContext({
        id: user.id,
        emailAddress: user.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
      });
    }
  }, [user]);

  const contextValue = {
    isInitialized,
  };

  return (
    <CoralogixContext.Provider value={contextValue}>
      {children}
    </CoralogixContext.Provider>
  );
};

export const useCoralogix = (): CoralogixContextType => {
  const context = useContext(CoralogixContext);
  if (!context) {
    throw new Error('useCoralogix must be used within a CoralogixProvider');
  }
  return context;
};

export default CoralogixContext;
